// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Twitter: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 58 58"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path
                style={{ transform: "translate(17px, 17px)" }}
                d="M14.3 10.2 23.2 0h-2.1l-7.7 8.8L7.1 0H0l9.4 13.3L0 24h2.1l8.2-9.3 6.5 9.3H24l-9.7-13.8zm-2.9 3.2-.9-1.3L2.9 1.6h3.2l6.1 8.5.9 1.3L21 22.5h-3.2l-6.4-9.1z"
            />
        </svg>
    );
};

export default React.memo(Twitter);
